import {
  MEDIUM_TYPE_CHIP,
  MEDIUM_TYPE_MAGNETIC_STRIPE,
  MEDIUM_TYPE_QR,
  MEDIUM_TYPE_REVERSE_QR
} from "../../../app/constants/mediumType";

type TextFn = (key: string) => string;

export function accessMediumTypeLabel(type: number, text: TextFn): string {
  if (type === MEDIUM_TYPE_CHIP) return text("Chip");
  if (type === MEDIUM_TYPE_REVERSE_QR) return text("Reverse-QR");
  if (type === MEDIUM_TYPE_QR) return text("QR");
  if (type === MEDIUM_TYPE_MAGNETIC_STRIPE) return text("Magnetic stripe card");
  return text("Other");
}
